export default __webpack_public_path__ + "4188569eda550ad656d0afea83a19f36.png";